import { GripVertical, Lock } from "lucide-react";
import React, { useState } from "react";
import { Checkbox } from "./checkbox";

const COLUMNS = [
	{ key: "customerNo", label: "Kundnr" },
	{ key: "vat", label: "Moms" },
	{ key: "created", label: "Skapad" },
];

/**
 * Live example for /component-showcase.
 *
 * The shadcn/Radix checkbox primitive on its own (unchecked / checked /
 * disabled), followed by the composition it was added for: the list-page column
 * settings rows, where the surrounding row owns the label, the hit area and the
 * drag grip.
 */
const CheckboxExample: React.FC = () => {
	const [checked, setChecked] = useState(true);
	const [visible, setVisible] = useState<string[]>(["customerNo", "created"]);

	const toggle = (key: string) =>
		setVisible((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]));

	return (
		<div className="flex flex-col gap-6">
			<p className="text-sm text-gray-600">
				A bare, unlabelled box for composing inside other Tailwind components. For a form field with
				label, hint, error text and react-hook-form wiring, use{" "}
				<code className="rounded bg-gray-100 px-1">Core/Checkbox/CheckboxNew</code> instead.
			</p>

			<div className="flex items-center gap-6">
				<label className="flex cursor-pointer items-center gap-2 text-sm">
					<Checkbox checked={checked} onCheckedChange={(v) => setChecked(v === true)} />
					Controlled
				</label>
				<label className="flex items-center gap-2 text-sm text-gray-500">
					<Checkbox checked disabled />
					Checked + disabled
				</label>
				<label className="flex items-center gap-2 text-sm text-gray-500">
					<Checkbox disabled />
					Disabled
				</label>
			</div>

			<div className="w-64 rounded-md border border-gray-200 p-2">
				<div className="px-1 pb-2 text-sm font-semibold">Kolumner</div>
				<div className="flex h-8 items-center gap-2 rounded-md px-1">
					<span className="flex h-6 w-4 shrink-0 items-center justify-center text-gray-400">
						<Lock className="h-3.5 w-3.5" />
					</span>
					<Checkbox checked disabled />
					<span className="flex-1 truncate text-sm">Namn</span>
				</div>
				{COLUMNS.map((col) => (
					<label
						key={col.key}
						className="flex h-8 cursor-pointer items-center gap-2 rounded-md px-1 hover:bg-gray-50"
					>
						<span className="flex h-6 w-4 shrink-0 cursor-grab items-center justify-center text-gray-400">
							<GripVertical className="h-4 w-4" />
						</span>
						<Checkbox checked={visible.includes(col.key)} onCheckedChange={() => toggle(col.key)} />
						<span
							className={`flex-1 truncate text-sm ${
								visible.includes(col.key) ? "" : "text-gray-400"
							}`}
						>
							{col.label}
						</span>
					</label>
				))}
			</div>
		</div>
	);
};

export default CheckboxExample;
